<template>
  <div id="app">
    <router-view />
    <Loader :view="loadingStatus" :msg="msg" />
  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import Loader from '@/components/common/Loader'
export default {
  name: 'App',
  components: { Loader },
  data() {
    return {
      msg: null,
      loadingStatus: false
    }
  },
  created() {
    bus.$on('startLoader', this.startLoader)
    bus.$on('endLoader', this.endLoader)
  },
  methods: {
    startLoader(msg) {
      this.msg = msg
      this.loadingStatus = true
    },
    endLoader() {
      this.loadingStatus = false
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
// override
// ==================== VUE - MULTISELECT ========================= //
.multiselect {
  .multiselect__select {
    height: 32px;
  }
  .multiselect__tags {
    display: flex;
    align-items: center;
    min-height: 32px;
    padding: 0;
    padding-right: 40px;
    padding-left: 10px;
    background-color: #f0f0f5;
    border: none;

    .multiselect__single,
    .multiselect__input {
      font-size: 14px;
      margin: 0;
      background-color: #f0f0f5;
    }
    .multiselect__input {
      padding-left: 5px;
    }
    .multiselect__placeholder {
      margin: auto 0;
    }
  }
  .multiselect__content-wrapper {
    // ul
    .multiselect__content {
      // li
      .multiselect__element {
        // span: multiselect__option multiselect__option--highlight multiselect__option--selected
        .multiselect__option {
          padding: 8px;
          padding-left: 16px;
          min-height: 32px;
          font-size: 14px;

          &::after {
            line-height: 32px;
            height: 32px;
            content: '';
          }

          &.multiselect__option--selected::after {
            background: url(./assets/icons/primary/icon_check.svg) no-repeat 0;
          }
        }
      }
    }
  }
}
</style>
